<template>
  <div class="tabs">
    <div
      v-if="currentTabIndex"
      class="left_block"
      :style="{ left: `calc(${currentTabIndex * 100}px - 6px)` }"
    >
      <div />
    </div>
    <div
      v-for="(item, index) in list"
      :key="index"
      class="tab"
      :class="{ tab_active: currentTabIndex == index }"
      @click="changTabs(index)"
    >
      {{ item.name }}
    </div>
    <div
      class="right_block"
      :style="{ left: `${(currentTabIndex + 1) * 100}px` }"
    >
      <div />
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  data() {
    return {
      currentTabIndex: 0,
      list: [
        {
          name: "圈友互动",
          question: 0,
        },
        // {
        //   name: "向老师提问",
        //   question: 1,
        // },
      ],
    };
  },
  mounted() {},
  methods: {
    changTabs(index) {
      this.currentTabIndex = index;
      this.$parent.changeQuestionStatus(
        this.list[this.currentTabIndex].question
      );
    },
    setTabs(index) {
      this.currentTabIndex = index;
    },
  },
};
</script>

<style scoped>
.tabs {
  position: relative;
  width: 100%;
  display: flex;
  height: 40px;
  box-sizing: border-box;
  background-color: #f9f9f9;
  border-bottom: 1px solid #dfdfdf;
}

.left_block,
.right_block {
  position: absolute;
  top: 1px;
  width: 6px;
  height: 100%;
  box-sizing: border-box;
  background-color: #fff;
}

.left_block div,
.right_block div {
  position: absolute;
  top: -1px;
  width: 100%;
  height: 100%;
  background-color: #f9f9f9;
  border-bottom: 1px solid #dfdfdf;
  z-index: 1;
}

.left_block div {
  border-radius: 0 0 6px 0;
  border-right: 1px solid #dfdfdf;
}

.right_block div {
  border-radius: 0 0 0 6px;
  border-left: 1px solid #dfdfdf;
}

.tab {
  width: 100px;
  height: 100%;
  font-weight: 400;
  font-size: 13px;
  color: #666666;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  border-bottom: 1px solid #dfdfdf;
}

.tab_active {
  position: relative;
  font-weight: 400;
  font-size: 13px;
  color: #333333;
  background-color: #fff;
}

.tab_active::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -1px;
  width: 100%;
  height: 1px;
  background-color: #fff;
}
</style>
